var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconMylistWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.305,
    height: 16.547,
    viewBox: "0 0 19.305 16.547",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-mylist-white",
    transform: "translate(-1143 -52.363)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bxs-dashboard",
    d: "M4.887,8.371H7.21A.387.387,0,0,0,7.6,7.984v-3.1A.387.387,0,0,0,7.21,4.5H4.887a.387.387,0,0,0-.387.387v3.1A.387.387,0,0,0,4.887,8.371ZM4.5,11.081a.387.387,0,0,0,.387.387H7.21a.387.387,0,0,0,.387-.387V9.533a.387.387,0,0,0-.387-.387H4.887a.387.387,0,0,0-.387.387Zm3.871,0a.387.387,0,0,0,.387.387h2.323a.387.387,0,0,0,.387-.387V8.371a.387.387,0,0,0-.387-.387H8.758a.387.387,0,0,0-.387.387ZM8.758,7.21h2.323a.387.387,0,0,0,.387-.387V4.887a.387.387,0,0,0-.387-.387H8.758a.387.387,0,0,0-.387.387V6.823A.387.387,0,0,0,8.758,7.21Z",
    transform: "translate(1144.5 50.582)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "monitor",
    transform: "translate(1140.75 47.863)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_15",
    "data-name": "\\u30D1\\u30B9 15",
    d: "M21.067,4.5H2.737a.491.491,0,0,0-.487.478V16.427a.485.485,0,0,0,.487.478h18.33a.491.491,0,0,0,.487-.478V4.978a.487.487,0,0,0-.487-.478Zm-.892,11.031H3.629V5.879H20.175Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_16",
    "data-name": "\\u30D1\\u30B9 16",
    d: "M17.821,29.322c1.207-.021,1.788-.168,1.25-.539s-1.228-.659-1.25-.97c-.013-.159-.074-1.939-.074-1.939H13.887s-.064,1.78-.074,1.939c-.021.306-.711.594-1.25.97s.043.517,1.25.539H17.82Z",
    transform: "translate(-3.915 -8.276)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMylistWhite);
export default __webpack_public_path__ + "static/media/icon-mylist-white.5bb67c9611244b3d6576418bb9f6bc43.svg";
export { ForwardRef as ReactComponent };